import { render, staticRenderFns, recyclableRender, components } from "./addition_subtraction.vue?vue&type=template&id=4cad58b4&scoped=true&"
var renderjs
import script from "./addition_subtraction.vue?vue&type=script&lang=js&"
export * from "./addition_subtraction.vue?vue&type=script&lang=js&"
import style0 from "./addition_subtraction.vue?vue&type=style&index=0&lang=css&"
import style1 from "./addition_subtraction.vue?vue&type=style&index=1&id=4cad58b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../soft/HBuilderX.4.08.2024040127/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cad58b4",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/addition_subtraction/addition_subtraction.vue"
export default component.exports